import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-primary-900/40 bg-primary-950 text-background-200">
      <div className="grid w-full gap-8 px-4 py-12 md:grid-cols-2 md:px-8 lg:grid-cols-4 lg:py-16">
        <div className="flex flex-col gap-4 lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-movie-2-fill text-lg" />
            </span>
            <span className="text-base font-extrabold tracking-tight text-background-50">
              男同视频
            </span>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-background-300/80">
            男同视频是一个专注于男同题材影像内容的文化平台，汇聚剧情、短片与专题作品，
            帮助观众便捷地发现、了解并探索属于自己的故事。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="text-sm font-bold text-background-50">
            <Link to="/category/drama">内容分类</Link>
          </h4>
          <Link
            to="/category/drama"
            className="w-fit text-sm text-background-300/80 transition-colors hover:text-accent-300"
          >
            剧情长片
          </Link>
          <Link
            to="/category/short"
            className="w-fit text-sm text-background-300/80 transition-colors hover:text-accent-300"
          >
            精选短片
          </Link>
          <Link
            to="/category/special"
            className="w-fit text-sm text-background-300/80 transition-colors hover:text-accent-300"
          >
            专题策划
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="text-sm font-bold text-background-50">
            <Link to="/about">关于与帮助</Link>
          </h4>
          <Link
            to="/about"
            className="w-fit text-sm text-background-300/80 transition-colors hover:text-accent-300"
          >
            关于我们
          </Link>
          <Link
            to="/search"
            className="w-fit text-sm text-background-300/80 transition-colors hover:text-accent-300"
          >
            内容搜索
          </Link>
          <Link
            to="/about"
            className="w-fit text-sm text-background-300/80 transition-colors hover:text-accent-300"
          >
            版权与免责声明
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="text-sm font-bold text-background-50">联系我们</h4>
          <span className="flex items-center gap-2 text-sm text-background-300/80">
            <i className="ri-mail-line text-accent-300" />
            hello@gayvideo-demo.com
          </span>
          <span className="flex items-center gap-2 text-sm text-background-300/80">
            <i className="ri-map-pin-line text-accent-300" />
            线上内容平台 · 服务全球观众
          </span>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-primary-900/50 px-4 py-6 text-xs text-background-300/70 md:flex-row md:px-8">
        <p>© {year} 男同视频 · 本站内容均为虚构演示内容，仅供学习交流使用。</p>
        <p>尊重多元 · 友善包容 · 内容合规</p>
      </div>
    </footer>
  );
}